import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Munck.css';
import { updatePageSEO, addStructuredData } from '../utils/SeoUtils';

// Munck equipment data
const munckEquipment = [
  {
    name: 'MUNCK CONVENCIONAL',
    specs: 'Modelo 45 ton.metro - 4 lanças hidráulicas - 3 manuais',
    slug: 'munck-convencional',
    image: '/images/equip/munck/munckConvencional.png',
    graficos: ['/images/equip/munck/grafico/munckConvencional_g1.png'],
  },
  {
    name: 'MUNCK ESPECIAL E8',
    specs: 'Modelo 46 ton.metro - 8 lanças hidráulicas - 1 manual',
    slug: 'munck-especial-e8',
    image: '/images/equip/munck/munckEspecialE8_3.png',
    graficos: ['/images/equip/munck/grafico/munckEspecialE8_g1.png'],
  },
  {
    name: 'MUNCK ESPECIAL FLYJIB',
    specs: 'Modelo 62 ton.metro - 5 lanças hidráulicas - FLYJIB com 4 hidráulicas - 2 manuais',
    slug: 'munck-especial-flyjib',
    image: '/images/equip/munck/munckEspecialFLYJIB.png',
    graficos: ['/images/equip/munck/grafico/munckEspecialFLYJIB_g1.png'],
  },
];

function Munck() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update SEO for Munck page
    updatePageSEO(
      'Locação de Munck em Rondonópolis - MEGATON',
      'Aluguel de muncks versáteis em Rondonópolis. Munck convencional, especial E8 e FLYJIB. Operadores certificados, equipamentos revisados.',
      'munck, locação munck, aluguel munck, rondonópolis, içamento, guindauto'
    );

    // Add structured data for munck listing
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Locação de Munck - MEGATON Rondonópolis',
      description: 'Muncks versáteis e eficientes para diversos tipos de içamento em Rondonópolis',
      itemListElement: munckEquipment.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item.name,
          description: item.specs,
          image: `https://megatonguindastes.com.br${item.image}`,
          url: `https://megatonguindastes.com.br/munck/${item.slug}`,
          category: 'Munck',
          brand: {
            '@type': 'Brand',
            name: 'MEGATON',
          },
        },
      })),
    };

    addStructuredData(structuredData);
  }, []);

  return (
    <div className="equipment">
      <section className="equipment-section">
        <div className="container">
          <h2 className="section-title">Munck</h2>
          <div className="equipment-cards">
            {munckEquipment.map((item, index) => (
              <div key={index} className="equipment-card">
                <Link to={`/munck/${item.slug}`} className="equipment-image-link">
                  <div className="equipment-image">
                    <img
                      src={item.image}
                      alt={item.name + ' em Rondonópolis, MT - Locação de Munck MEGATON'}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </Link>
                <div className="equipment-info">
                  <h3>{item.name}</h3>
                  <p className="equipment-specs">{item.specs}</p>
                  {item.slug === 'munck-convencional' && (
                    <ul className="equipment-highlights">
                      <li>Capacidade: 11 ton a 4,2m</li>
                      <li>Alcance: 12 metros</li>
                    </ul>
                  )}
                  {item.slug === 'munck-especial-e8' && (
                    <ul className="equipment-highlights">
                      <li>Capacidade: 9 ton a 4,5m</li>
                      <li>Alcance: 20 metros</li>
                    </ul>
                  )}
                  {item.slug === 'munck-especial-flyjib' && (
                    <ul className="equipment-highlights">
                      <li>Capacidade: 12 ton a 4,2m</li>
                      <li>Alcance: 31 metros</li>
                    </ul>
                  )}
                  <Link to={`/munck/${item.slug}`} className="details-btn">
                    Ver detalhes
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="equipment-features">
        <div className="container">
          <h2>Vantagens dos Nossos Muncks</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h4>🔧 Manutenção Preventiva</h4>
              <p>Inspeções regulares e manutenção preventiva para máxima confiabilidade</p>
            </div>
            <div className="feature-item">
              <h4>👨‍🔧 Operadores Certificados</h4>
              <p>Equipe experiente e certificada para operações seguras e eficientes</p>
            </div>
            <div className="feature-item">
              <h4>🛡️ Segurança Garantida</h4>
              <p>Equipamentos com dispositivos de segurança e sistemas de monitoramento</p>
            </div>
            <div className="feature-item">
              <h4>⚡ Disponibilidade 24h</h4>
              <p>Atendimento de emergência disponível 24 horas para situações urgentes</p>
            </div>
          </div>
        </div>
      </section>

      <section className="equipment-applications">
        <div className="container">
          <h2>Aplicações para Muncks</h2>
          <div className="applications-grid">
            <div className="application">
              <h4>Construção Civil</h4>
              <ul>
                <li>Posicionamento de materiais</li>
                <li>Montagem de estruturas metálicas</li>
                <li>Içamento de painéis pré-moldados</li>
                <li>Instalação de equipamentos</li>
              </ul>
            </div>
            <div className="application">
              <h4>Serviços Residenciais</h4>
              <ul>
                <li>Içamento de piscinas</li>
                <li>Paisagismo e jardinagem</li>
                <li>Instalação de caixas d'água</li>
                <li>Mudanças especiais</li>
              </ul>
            </div>
            <div className="application">
              <h4>Indústria</h4>
              <ul>
                <li>Movimentação de maquinários</li>
                <li>Manutenção industrial</li>
                <li>Instalação de equipamentos</li>
                <li>Carregamento de containers</li>
              </ul>
            </div>
            <div className="application">
              <h4>Agronegócio</h4>
              <ul>
                <li>Montagem de silos</li>
                <li>Equipamentos agrícolas</li>
                <li>Estruturas rurais</li>
                <li>Sistemas de irrigação</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Precisa de um Munck?</h2>
          <p>Solicite um orçamento personalizado para seu projeto</p>
          <Link to="/contato" className="cta-btn">
            Solicitar Orçamento
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Munck;
